export const resolveRuntimeHost = (
  configuredUrl?: string,
  browserHost = typeof window === 'undefined' ? undefined : window.location.hostname,
) => {
  if (!configuredUrl || !browserHost) return configuredUrl
  if (browserHost === 'localhost' || browserHost === '127.0.0.1') return configuredUrl

  return configuredUrl.replace(
    /\/\/(localhost|127\.0\.0\.1)(?=[:/]|$)/,
    `//${browserHost}`,
  )
}

export const backendUrl = resolveRuntimeHost(process.env.REACT_APP_API_URL)
export const shortUrl = resolveRuntimeHost(process.env.REACT_APP_SHORT_URL)
export const mediaUrl = resolveRuntimeHost(process.env.REACT_APP_MEDIA_URL)
export const storageUrl = resolveRuntimeHost(process.env.REACT_APP_AWS_S3_ENDPOINT_URL)
